var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoTriangleAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_info",
    "data-name": "icon info",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20.783,
    height: 19.058,
    viewBox: "0 0 20.783 19.058",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5189",
    "data-name": "Rectangle 5189",
    width: 20.783,
    height: 19.058,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6861",
    "data-name": "Group 6861",
    transform: "translate(-0.011 0.942)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5184",
    "data-name": "Rectangle 5184",
    width: 2,
    height: 2,
    transform: "translate(11.397 13.43) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5185",
    "data-name": "Rectangle 5185",
    width: 2,
    height: 6,
    transform: "translate(11.397 9.43) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6863",
    "data-name": "Group 6863",
    transform: "translate(0.011 -0.942)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5187",
    "data-name": "Rectangle 5187",
    width: 2,
    height: 2,
    transform: "translate(9.391 13.093)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5188",
    "data-name": "Rectangle 5188",
    width: 2,
    height: 6,
    transform: "translate(9.391 5.093)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6864",
    "data-name": "Group 6864"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6863-2",
    "data-name": "Group 6863",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8997",
    "data-name": "Path 8997",
    d: "M10.34,0a3.4,3.4,0,0,1,2.98,1.725l7.006,12.184a3.436,3.436,0,0,1-2.98,5.149H3.438A3.438,3.438,0,0,1,.447,13.927l6.9-12.183A3.4,3.4,0,0,1,10.327,0h.011m7.008,17.057A1.437,1.437,0,0,0,18.589,14.9l-7-12.183A1.42,1.42,0,0,0,10.344,2h-.005a1.423,1.423,0,0,0-1.246.73l-6.9,12.183a1.437,1.437,0,0,0,1.249,2.145Z",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoTriangleAlert);
export default __webpack_public_path__ + "static/media/ico-triangle-alert.51d1e4e99d41c265fd6d78bc281f3ad4.svg";
export { ForwardRef as ReactComponent };